import { AsyncPipe } from '@angular/common';
import { Component, computed, effect, inject, input, output, ViewChild } from '@angular/core';
import { oofApi, oofDtos } from '@vectronic/openApi-admin';
import { ChipsAutocompleteComponent, FilterHeaderComponent, Item } from '@vectronic/ui';
import { BehaviorSubject, debounceTime, map, Observable, of, shareReplay, switchMap } from 'rxjs';

@Component({
  selector: 'table-datatable-filter-process-id',
  templateUrl: './datatable-filter-process-id.component.html',
  imports: [AsyncPipe, ChipsAutocompleteComponent, FilterHeaderComponent],
})
export class DatatableFilterProcessIdComponent {
  private adminOrdersApi = inject(oofApi.AdminOrders);

  title = input.required<string>();
  value = input<string[] | undefined>();
  expanded = input.required<boolean>();
  disabled = input(false);

  valueChange = output<string[]>();
  toggled = output<void>();

  @ViewChild(ChipsAutocompleteComponent)
  private chipsAutocompleteComponent: ChipsAutocompleteComponent<string>;

  filterText = new BehaviorSubject('');
  selectedItems = computed<Item<string>[]>(() =>
    (this.value() ?? []).map((processId) => ({ name: processId, value: processId })),
  );

  // noinspection JSUnusedGlobalSymbols
  focusFilterInputOnShow = effect(() => {
    if (this.expanded() && !this.value()?.length) {
      this.chipsAutocompleteComponent?.focusInput();
    }
  });

  availableFilterItems$: Observable<Item<string>[]> = this.filterText.pipe(
    debounceTime(500),
    switchMap((text) =>
      text?.length > 1 ? this.adminOrdersApi.getOrdersByFakturaIdContains(text) : of([]),
    ),
    map((orders: oofDtos.Order[]) =>
      Array.from(
        new Set(
          orders
            .map((order) => order.fakturaId)
            .filter((fakturaId): fakturaId is string => Boolean(fakturaId)),
        ),
      ).map((processId) => ({ name: processId, value: processId })),
    ),
    shareReplay(1),
  );

  onSelectFilterItem(selectedItem: Item<string>) {
    if (this.disabled()) return;

    this.valueChange.emit([...(this.value() ?? []), selectedItem.value]);
  }

  onDeleteFilterItem(deletedItem: Item<string>) {
    if (this.disabled()) return;

    this.valueChange.emit(
      (this.value() ?? []).filter((processId) => processId !== deletedItem.value),
    );
  }

  filterTextChanged(text: string) {
    if (this.disabled()) return;

    this.filterText.next(text);
  }
}
